import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../types/store";

import AppActions from "../actions/app-actions";
import AppUtils from "../utils/app-utils";

import Index from "../pages/index";
import CreatePick from "../pages/create/pick";
import Create from "../pages/create/create";
import Join from "../pages/join";
import Lobby from "../pages/lobby/lobby";
import Help from "../pages/help";
import Speaker from "../pages/speaker";
import NotFound from "../pages/404";

import AuthContainer from "../components/auth-container";
import UICookieConsent from "./ui-cookieconsent.tsx";

import DefaultLayout from "../layouts/default-layout.tsx";
import LobbyLayout from "../layouts/lobby-layout.tsx";
//import TestTv from "../pages/test-tv.tsx";

const App = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.auth.user);

    useEffect(() => {
        if (user.id <= 0) {
            const cookie = AppUtils.getLoginCookie();
            if (cookie && cookie.length > 0) {
                dispatch(AppActions.LoginToken({ token: cookie }));
            }
        }
    }, []);

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <>
                        <AuthContainer />
                        <DefaultLayout />
                        <UICookieConsent />
                    </>
                }
            >
                <Route index path="/" element={<Index />} />
                <Route path="/create/:mode" element={<Create />} />
                <Route path="/create" element={<CreatePick />} />
                <Route path="/join/:code" element={<Join />} />
                <Route path="/join" element={<Join />} />
                <Route path="/speaker" element={<Speaker />} />
            </Route>
            <Route
                path="/lobby/:code"
                element={
                    <LobbyLayout>
                        <Lobby />
                    </LobbyLayout>
                }
            />
            {/*<Route path="/test-tv" element={<TestTv />} />
            <Route path="/preview" element={<TestTv />} />*/}
            <Route path="/help" element={<Help />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default App;
